/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNSAxMS41VjE0LjVIMTQuNVYxMS41TTUuNSAzLjVIMC41VjkuNUgxNS41VjMuNUgxMC41TTUuNSAzLjVWMC41SDEwLjVWMy41TTUuNSAzLjVIMTAuNSIvPjwvc3ZnPg==";